import { render } from "./CheckboxModule.vue?vue&type=template&id=30b5e003&scoped=true"
import script from "./CheckboxModule.vue?vue&type=script&lang=js"
export * from "./CheckboxModule.vue?vue&type=script&lang=js"

import "./CheckboxModule.vue?vue&type=style&index=0&id=30b5e003&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b5e003"]])

export default __exports__